import React from 'react';
import PropTypes from 'prop-types';

// Form Elements
import Instructions from '../../../FormElements/Instructions';
import PortalCheckbox from '../../../FormElements/PortalCheckbox';
import PortalCheckboxGroup from '../../../FormElements/PortalCheckboxGroup';
import PortalDatePicker from '../../../FormElements/PortalDatePicker';
import PortalRadioButtonGroup from '../../../FormElements/PortalRadioButtonGroup';
import PortalSelectField from '../../../FormElements/PortalSelectField';
import PortalTextField from '../../../FormElements/PortalTextField';
import SectionHeader from '../../../FormElements/SectionHeader';
import Spacer from '../../../FormElements/Spacer';

import s from './FormElementList.css';


const FormElementList = ({ formElements, updateValue, formId, autosave }) => {
  if (!formElements || formElements.length === 0) {
    return null;
  }

  const renderableFormElements = formElements.map(formElement => {
    const label = formElement.required ?
      <div><span>{formElement.label}</span><span className={s.required}>*</span></div> :
      <div>{formElement.label}</div>;
    const componentKey = formElement.id + ":" + formId;

    switch (formElement.type) {
      case 'textbox':
        return <PortalTextField key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          name={formElement.id}
          required={formElement.required}
          value={formElement.value}
          onChange={(event, value) => updateValue(formElement.id, value) }
          onBlur={autosave}
        />;
      case 'textarea':
        return <PortalTextField key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          name={formElement.id}
          required={formElement.required}
          value={formElement.value}
          multiLine
          onChange={(event, value) => updateValue(formElement.id, value) }
          onBlur={autosave}
        />;
      case 'checkbox':
        return <PortalCheckbox key={componentKey}
          description={formElement.description}
          id={formElement.id}
          label={formElement.label}
          name={formElement.label}
          onChange={(event, isChecked) => updateValue(formElement.id, isChecked ? "true" : '')}
          checked={formElement.value === formElement.label || formElement.value === "true"}
          onBlur={autosave}
        />;
      case 'checklist':
        return <PortalCheckboxGroup key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          name={formElement.id}
          options={formElement.list}
          required={formElement.required}
          onChange={(event, value) => updateValue(formElement.id, value) }
          checked={formElement.value ? formElement.value : []}
          onBlur={autosave}
        />;
      case 'radiolist':
        return <PortalRadioButtonGroup key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          name={formElement.id}
          options={formElement.list}
          required={formElement.required}
          value={formElement.value}
          onChange={(event, value) => updateValue(formElement.id, value)}
          onBlur={autosave}
        />;
      case 'dropdown':
        return <PortalSelectField key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          ariaLabel={formElement.label}
          name={formElement.id}
          options={formElement.list}
          required={formElement.required}
          value={formElement.value}
          onChange={(event, value) => updateValue(formElement.id, value)}
          onBlur={autosave}
        />;
      case 'datebox':
        return <PortalDatePicker key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          name={formElement.id}
          required={formElement.required}
          value={formElement.value ? new Date(formElement.value) : null}
          onChange={value => updateValue(formElement.id, value)}
          onBlur={autosave}
        />;
      case 'label':
        return <Instructions key={componentKey}
          id={formElement.id}
          label={formElement.label}
        />;
      case 'section':
        return <SectionHeader key={componentKey}
          id={formElement.id}
          label={formElement.label}
        />;
      case 'spacer':
        return <Spacer key={componentKey} id={formElement.id} />;
      default:
        return <PortalTextField key={componentKey}
          description={formElement.description}
          errorText={formElement.error}
          id={formElement.id}
          label={label}
          name={formElement.id}
          required={formElement.required}
          value={formElement.value}
          onChange={(event, value) => updateValue(formElement.id, value) }
          onBlur={autosave}
        />;
    }
  });

  return (
    <div id="formElements">
      {renderableFormElements}
    </div>
  );
};

FormElementList.propTypes = {
  formElements: PropTypes.array,
};

export default FormElementList;



// WEBPACK FOOTER //
// ./src/components/Pages/Forms/FormElementList/FormElementList.js